import { BILLING_CYCLE, BILLING_PERIOD } from './constants'
import { getDate, getShortDate } from '../../utils/dateTime'
import { PRODUCT_NAMES_LIST } from '../../common/constants/ProductConstants'

const isPriceType = type => type === BILLING_PERIOD.month || type === BILLING_PERIOD.annual
const isPriceName = name =>
    name === PRODUCT_NAMES_LIST.Free ||
    name === PRODUCT_NAMES_LIST.Starter ||
    name === PRODUCT_NAMES_LIST.Professional ||
    name === PRODUCT_NAMES_LIST.Enterprise
export const isPayload = location =>
    location.state &&
    location.state.payload &&
    isPriceType(location.state.payload.priceType) &&
    isPriceName(location.state.payload.priceName)

export const calculateFormattedExpirationDate = date => (BILLING_CYCLE.year ? getDate(date) : getShortDate(date))

export const getFormattedPrice = (price, currency) => {
    if (currency === 'USD') return `$${price.toFixed(2)}`
    else if (currency === 'RUB') return `${price.toFixed(2)} ₽`
    return null
}
